import DropAnchor from "lib/Draggable/DropAnchor";
import { classnames, onReturnKey } from "lib/helpers";
import { forwardRef, useContext, useEffect, useRef, useState } from "react";
import { TreeContext } from "pages/Editor";
import Schema from "./Schema";

function Panel({ children, path, value, name, style }, ref) {
  const title = useRef();
  const { component, context, update, selection, subscribe } =
    useContext(TreeContext);
  const [editing, setEditing] = useState(false);
  useEffect(() => {
    // issue #4
    if (context === "render") {
      const topic = component.id || path;
      return subscribe(topic, (data) => {
        if (data === "SEND_LOCATION") {
          console.log("sending location of", value || name);
        }
      });
    }
  }, [component.id, context, name, path, subscribe, value]);
  const content = <Schema component={children} path={path + ".children"} />;
  const onKeyDown = (e) => {
    onReturnKey(() => {
      setEditing(false);
      update(path + ".value", e.target.innerText);
    })(e);
  };
  const onDoubleClick = (e) => {
    e.preventDefault();
    setEditing(true);
  };
  const onClick = (e) => {
    if (selection) {
    } else return;
    // prevent unselecting during double click
    e.stopPropagation();
  };
  const stopEditing = () => setEditing(false);
  useEffect(() => {
    if (editing) title.current.focus();
  }, [editing]);
  useEffect(() => {
    title.current.innerText = value || name;
  }, [name, value]);
  return (
    <div className="pn" {...{ ref, style }}>
      <div
        className="pn-h"
        ref={title}
        contentEditable={editing}
        {...{ onClick, onDoubleClick, onKeyDown }}
        onBlur={stopEditing}
      ></div>
      <div className={classnames("pn-b", { c: children })}>
        {content}
        {!children && <DropAnchor path={path + ".children"} />}
      </div>
    </div>
  );
}

export default forwardRef(Panel);
